import { render } from "./CompanyViewPage.vue?vue&type=template&id=0b60ceb5&scoped=true"
import script from "./CompanyViewPage.vue?vue&type=script&lang=js"
export * from "./CompanyViewPage.vue?vue&type=script&lang=js"

import "./CompanyViewPage.vue?vue&type=style&index=0&id=0b60ceb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b60ceb5"]])

export default __exports__